import { useQuery } from '@tanstack/react-query';
import { Flags, useFlag } from 'ui';
import { getCaseById } from 'services/ClaimscoreApiService/Cases';
import { Case } from 'services/ClaimscoreApiService/Cases/types';
import { ClaimScoreApiVersion } from 'services/ClaimscoreApiService/types';

const QUERY_KEY = 'getCaseById';

export const useGetCaseById = (caseId: string) => {
  const isWordingActive = useFlag(Flags.wording);
  const version = isWordingActive ? ClaimScoreApiVersion.V2_5 : undefined;
  return useQuery<Case, Error>({
    queryKey: [QUERY_KEY, caseId, version],
    queryFn: () => getCaseById(caseId, version),
    enabled: Boolean(caseId),
  });
};
